module.exports = __webpack_public_path__ + "img/success_text.496e5a6d.png";